import { render, staticRenderFns } from "./ManageUsersView.vue?vue&type=template&id=b6c949ac&"
import script from "./ManageUsersView.vue?vue&type=script&lang=ts&"
export * from "./ManageUsersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports